import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BbitWebShopNotificationService } from '@bbitgmbh/webshop.sdk';
import { BbitCookieState, BbitGdprService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { FooterComponent } from './footer/footer.component';
import { NavComponent } from './nav/nav.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, RouterOutlet, FooterComponent, NgIcon, AsyncPipe, I18nPipe],
  // imports: [TempUpdatingComponent],
})
export class AppComponent {
  public BbitCookieState = BbitCookieState;
  private _router = inject(Router);
  public isTv = signal(false);
  constructor(
    // private _algolia: BbitWebShopAlgoliaService,
    public notification: BbitWebShopNotificationService,
    // private _api: BbitWebShopApiService,
    public gdpr: BbitGdprService,
  ) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/tv') {
          this.isTv.set(true);
        } else {
          this.isTv.set(false);
        }
      }
    });
  }
}
